const nextTick = (callback = null) => new Promise((resolve) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            if (callback) callback();
            resolve();
        });
    });
});

export default nextTick;
